<template>
	<div
	class="explore-button"
	:class="{ center: center, seen: seen }"
	@pointerdown.stop
	@mouseover="hover = true"
	@mouseleave="hover = false"
	@click.prevent="click">
		<b-icon class="icon" icon="search"></b-icon>
		<!-- <b class="position-absolute translate-middle" style="left: 50%; top: 50%;">?</b> -->
	</div>
</template>



<script>
export default {
	props: { "cardValue": String, "center": Boolean },
	data() {
		return {
			seen: false,
			hover: false,
		};
	},
	methods: {
		click() {
			this.seen = true;
			this.$emit('click');
		},
		update() {
			this.seen = false;
			try {
				if (localStorage.getItem("exploredCards")) {
					this.seen = !!JSON.parse(localStorage.getItem("exploredCards"))[this.cardValue];
				}
			} catch (error) {
				console.error("Unintended:", error);
			}
		}
	},
	mounted() {
		this.update();
	},
	watch: {
		cardValue() {
			this.update();
		}
	},
};
</script>



<style scoped>
	.explore-button {
		position: absolute;
		transform: translate(-50%, -50%);
		background-color: var(--bs-light);
		color: var(--bs-dark);
		font-size: 12px;

		border: 1px solid var(--bs-dark);
		cursor: pointer;
		width: 28px;
		height: 28px;
		border-radius: 100em;

		/*left: calc(100% - 20px/2*0 - 0.2em - 1px);*/
		/*top: calc(100% - 20px/2*0 - 0.2em - 1px);*/
		left: calc(0% + 0.2em + 1px);
		top: calc(0% + 0.2em + 1px);

		transition: all 50ms ease-out;
	}
	.explore-button:hover {
		transform: translate(-50%, -50%) scale(1.5);
		/*width: calc(1.5*20px);*/
		/*height: calc(1.5*20px);*/
		/*font-size: calc(1.5*12px);*/
	}
	.explore-button:active {
		transform: translate(-50%, -50%) scale(1.2);
	}

	.seen {
		color: #4A50C0;
		border-color: #4A50B0;
		width: 18px;
		height: 18px;
		opacity: 0.7;
	}
	.seen:hover {
		opacity: 1.0;
	}

	.center {
		left: 50% !important;
		top: 50% !important;
	}

	.icon {
		position: absolute;
		transform: translate(-51%, -51%);
		left: 50%;
		top: 50%;
		padding: 12px;
		width: calc(15px + 2*12px);
		height: calc(15px + 2*12px);

		border-radius: 100%;
		/*background-color: #ff000077;*/
	}
	.seen .icon {
		width: calc(11px + 2*12px);
		height: calc(11px + 2*12px);
	}
</style>
